import React from 'react';
import { DriveSVG } from '../../@common_components/svgs/drive.svg';
import { BaseIconComponent, IconProps } from '@umanforge/common';

const DriveIcon: React.FC<Omit<IconProps, 'svg'>> = props => {
  return <BaseIconComponent {...props} svg={<DriveSVG />} />;
};

export { DriveIcon };